var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20225 15.3381C1.08623 15.3381 0.999219 15.2994 0.941211 15.2221C0.902539 15.1447 0.921875 15.0674 0.999219 14.99L5.84291 8.08711C5.88159 8.0291 5.88159 7.97109 5.84291 7.91309L0.999219 1.01016C0.960547 0.971485 0.941211 0.923145 0.941211 0.865138C0.941211 0.729786 1.02822 0.662109 1.20225 0.662109H2.76847C2.92316 0.662109 3.03918 0.720118 3.11652 0.836134L6.91607 6.31787C6.9354 6.33721 6.96441 6.34688 7.00308 6.34688C7.04175 6.34688 7.07076 6.33721 7.09009 6.31787L10.8606 0.836134C10.938 0.720118 11.054 0.662109 11.2087 0.662109H12.9199C13.0359 0.662109 13.1133 0.700781 13.152 0.778125C13.1906 0.836134 13.1713 0.913477 13.094 1.01016L8.25026 7.91309C8.23092 7.97109 8.23092 8.0291 8.25026 8.08711L13.094 14.99C13.1326 15.0287 13.152 15.0867 13.152 15.1641C13.152 15.2027 13.1326 15.2414 13.094 15.2801C13.0553 15.3188 12.9973 15.3381 12.9199 15.3381H11.3247C11.17 15.3381 11.054 15.2801 10.9766 15.1641L7.20611 9.68232C7.18677 9.64365 7.15777 9.62432 7.1191 9.62432C7.08042 9.62432 7.05142 9.64365 7.03208 9.68232L3.20354 15.1641C3.12619 15.2801 3.01017 15.3381 2.85549 15.3381H1.20225Z",
    fill: "#7A7784"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b1baa855cc0e9adf0dc5472a90e3e3ac.svg";
export { ForwardRef as ReactComponent };